'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Weixin = function () {
    function Weixin() {
        _classCallCheck(this, Weixin);

        this.type = 'weixin';
        this.keeper = undefined;
    }

    _createClass(Weixin, [{
        key: 'process',
        value: function process(succ, _fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof _fail == 'function' || (_fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                // API超时、用户拒绝授权
                _fail({
                    code: 408,
                    message: _this.type + ' API Timeout:' + opt.timeout,
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            this.initSDK(function () {
                try {
                    // 说明: `回调未执行`先用超时来统计，包含两部分 -> checkJsApi & getLocation
                    wx.ready(function () {
                        wx.checkJsApi({
                            jsApiList: ['getLocation'],
                            success: function success(res) {
                                if (res.checkResult && res.checkResult.getLocation) {
                                    wx.getLocation({
                                        type: 'wgs84',
                                        success: function success(res) {
                                            succ({
                                                lat: res.latitude,
                                                lng: res.longitude,
                                                type: _this.type
                                            }, _this.keeper.getToken());
                                        },
                                        fail: function fail() {
                                            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                            // TODO: 用户授权失败标识
                                            _fail({
                                                message: e.message || e.errMsg || JSON.stringify(e),
                                                type: _this.type
                                            }, _this.keeper.getToken());
                                        }
                                    });
                                } else {
                                    // 说明：config中未匹配的域名、jsApiList没有指定`getLocation`都进入此分支
                                    _fail({
                                        code: 400,
                                        message: 'wx checkJsApi error',
                                        title: 'weixin-checkJsApi',
                                        type: _this.type
                                    }, _this.keeper.getToken());
                                }
                            },
                            fail: function fail() {
                                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                _fail({
                                    code: 400,
                                    message: e.message || e.errMsg || 'wx checkJsApi fail',
                                    title: 'weixin-checkJsApi',
                                    type: _this.type
                                }, _this.keeper.getToken());
                            }
                        });
                    });
                    // TODO: 可能有误操作，beta
                    wx.error(function () {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        console.log('wx config error');
                        _fail({
                            code: 400,
                            message: e.message || e.errMsg || 'wx config error',
                            title: 'weixin-config',
                            type: _this.type
                        }, _this.keeper.getToken());
                    });
                } catch (e) {
                    console.log('wx exception');
                    _fail({
                        code: 400,
                        message: 'wx init error',
                        type: _this.type
                    }, _this.keeper.getToken());
                }
            });
        }
    }, {
        key: 'initSDK',
        value: function initSDK(action) {
            if (_config2.default.get('wxAutoConfig') && typeof wx === 'undefined') {
                // 说明：同一个url仅需验证一次
                require.ensure([], function () {
                    var loader = require('@dp/weixin-js-sdk-loader');
                    loader.use(action);
                }, 'whereami-weixin');
            } else {
                action();
            }
        }
    }, {
        key: 'supportGeo',
        value: function supportGeo() {
            return (/MicroMessenger/.test(navigator.userAgent)
            );
        }
    }]);

    return Weixin;
}();

var instance = new Weixin();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/weixin.js
// module id = 427
// module chunks = 10 11 12 13 14